import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { LoginService } from './login.service';

import { Ranking } from '../models/ranking';
import { RankingRuleResponse } from '../models/ranking.rule';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable()
export class ProfileService {

  private URL: string = environment.urlbase;
  private headers: HttpHeaders;

  constructor(
    private http: HttpClient,
    private loginService: LoginService
  ) {
    this.headers = this.loginService.getHeaders();
  }

  /* =================================================
     ---------- U S E R   F U N C T I O N S ----------
     =================================================*/



  /* =======================================================
     ---------- R A N K I N G   F U N C T I O N S ----------
     =======================================================*/

  ranking(): Observable<Ranking> {
    this.headers = this.loginService.getHeaders();
    const rankingExt: string = 'gamifications/ranking';
    return this.http.get<Ranking>(this.URL + rankingExt, {headers: this.headers});
  }

  rules(): Observable<RankingRuleResponse> {
    this.headers = this.loginService.getHeaders();
    const rankingRulesExt: string = 'gamifications/rules';
    return this.http.get<RankingRuleResponse>(this.URL + rankingRulesExt, {headers: this.headers});
  }

}
